export const ProductStatus = {
    NOT_MODIFIABLE: 'NOT_MODIFIABLE',
    MODIFICATION_IN_PROGRESS: 'MODIFICATION_IN_PROGRESS'
}

export const ProductStatusClassname = {
    NOT_MODIFIABLE: 'active',
    MODIFICATION_IN_PROGRESS: 'editInProgress'
}
